export default __webpack_public_path__ + "static/media/Checklist for New HSL OpenMaaS Users_14Jan2021.1a550bb4.pdf";